unit UVmPosModel;

interface

uses
  UMatModel, JS, UEssentialHelper, UFakModel;

type
  TVmPosModel = class
  private
    FPersonalNr: string;
    FMat: TMatModel;
    FMenge: Double;
    FCreatedAt: TDateTime;
    FTransmittedAt: TDateTime;
    FFak: TFakModel;
    FName: string;
    FVorname: string;
    FOnPropertyChanged: TPropertyChangedEvent;
    FSelected: Boolean;
    procedure ClearValues;
    procedure DoPropertyChanged(PropertyName: string);
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetCreatedAt(const Value: TDateTime);
    procedure SetMat(const Value: TMatModel);
    procedure SetMenge(const Value: Double);
    procedure SetPersonalNr(const Value: string);
    procedure SetTransmittedAt(const Value: TDateTime);
    procedure SetFak(const Value: TFakModel);
    procedure SetName(const Value: string);
    procedure SetVorname(const Value: string);
    procedure SetOnPropertyChanged(const Value: TPropertyChangedEvent);
    procedure SetSelected(const Value: Boolean);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    function Equals(Other: TVmPosModel): Boolean;
    function ToJson: string;
    property Mat: TMatModel read FMat write SetMat;
    property Menge: Double read FMenge write SetMenge;
    property CreatedAt: TDateTime read FCreatedAt write SetCreatedAt;
    property TransmittedAt: TDateTime read FTransmittedAt
      write SetTransmittedAt;
    property PersonalNr: string read FPersonalNr write SetPersonalNr;
    property Fak: TFakModel read FFak write SetFak;
    property Name: string read FName write SetName;
    property Vorname: string read FVorname write SetVorname;
    property OnPropertyChanged: TPropertyChangedEvent read FOnPropertyChanged
      write SetOnPropertyChanged;
    property Selected: Boolean read FSelected write SetSelected;
  end;

implementation

uses
  WebLib.Json, System.SysUtils;

{ TVmPosModel }

procedure TVmPosModel.ClearValues;
begin
  Self.Mat := nil;
  Self.Menge := 1;
  Self.CreatedAt := now;
  Self.TransmittedAt := 0;
  Self.PersonalNr := '';
  Self.Fak := nil;
  Self.Name := '';
  Self.Vorname := '';
  Self.FSelected := false;
end;

constructor TVmPosModel.Create;
begin
  Self.ClearValues;
end;

constructor TVmPosModel.Create(Json: string);
begin
  Self.SetValues(Json);
end;

procedure TVmPosModel.DoPropertyChanged(PropertyName: string);
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self, PropertyName);
end;

function TVmPosModel.Equals(Other: TVmPosModel): Boolean;
var
  m, m1: TMatModel;
  f, f1: TFakModel;
  s, t: string;
begin
  Result := true;
  if Other <> nil then
  begin
    if Self.Mat <> nil then
    begin
      m := Self.Mat;
      if Other.Mat <> nil then
      begin
        m1 := Other.Mat;
        Result := Result and (m.ArtNr = m1.ArtNr);
      end
      else
        Result := Result and false;
    end
    else
    begin
      if Other.Mat <> nil then
        Result := Result and false
      else
        Result := Result and true;
    end;
    if Self.Fak <> nil then
    begin
      f := Self.Fak;
      if Other.Fak <> nil then
      begin
        f1 := Other.Fak;
        Result := Result and (f.Nr = f1.Nr);
      end
      else
        Result := Result and false;
    end
    else
    begin
      if Other.Fak <> nil then
        Result := Result and false
      else
        Result := Result and true;
    end;
    Result := Result and (Self.Menge = Other.Menge);
    s := DateTimeToStr(Self.CreatedAt);
    t := DateTimeToStr(Other.CreatedAt);
    Result := Result and (s = t);
    Result := Result and (Self.PersonalNr = Other.PersonalNr);
  end
  else
    Result := false;
end;

procedure TVmPosModel.SetCreatedAt(const Value: TDateTime);
begin
  FCreatedAt := Value;
  Self.DoPropertyChanged('CreatedAt');
end;

procedure TVmPosModel.SetFak(const Value: TFakModel);
begin
  FFak := Value;
  Self.DoPropertyChanged('Fak');
end;

procedure TVmPosModel.SetMat(const Value: TMatModel);
begin
  FMat := Value;
  Self.DoPropertyChanged('Mat');
end;

procedure TVmPosModel.SetMenge(const Value: Double);
begin
  FMenge := Value;
  Self.DoPropertyChanged('Menge');
end;

procedure TVmPosModel.SetName(const Value: string);
begin
  FName := Value;
  Self.DoPropertyChanged('Name');
end;

procedure TVmPosModel.SetOnPropertyChanged(const Value: TPropertyChangedEvent);
begin
  FOnPropertyChanged := Value;
  Self.DoPropertyChanged('OnPropertyChanged');
end;

procedure TVmPosModel.SetPersonalNr(const Value: string);
begin
  FPersonalNr := Value;
  Self.DoPropertyChanged('PersonalNr');
end;

procedure TVmPosModel.SetSelected(const Value: Boolean);
begin
  if FSelected <> Value then
  begin
    FSelected := Value;
    Self.DoPropertyChanged('Selected');
  end;
end;

procedure TVmPosModel.SetTransmittedAt(const Value: TDateTime);
begin
  FTransmittedAt := Value;
  Self.DoPropertyChanged('TransmittedAt');
end;

procedure TVmPosModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['Mat'] <> nil then
    Self.Mat := TMatModel.Create(string(Obj['Mat']));
  if Obj['Menge'] <> nil then
    Self.Menge := StrToFloat(string(Obj['Menge']));
  if Obj['CreatedAt'] <> nil then
    Self.CreatedAt := StrToDateTime(string(Obj['CreatedAt']));
  if Obj['TransmittedAt'] <> nil then
    Self.TransmittedAt := StrToDateTime(string(Obj['TransmittedAt']));
  if Obj['PersonalNr'] <> nil then
    Self.PersonalNr := string(Obj['PersonalNr']);
  if Obj['Fak'] <> nil then
    Self.Fak := TFakModel.Create(string(Obj['Fak']));
  if Obj['Name'] <> nil then
    Self.Name := string(Obj['Name']);
  if Obj['Vorname'] <> nil then
    Self.Vorname := string(Obj['Vorname']);
end;

procedure TVmPosModel.SetVorname(const Value: string);
begin
  FVorname := Value;
  Self.DoPropertyChanged('Vorname');
end;

procedure TVmPosModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

function TVmPosModel.ToJson: string;
var
  Obj: TJsonObject;
begin
  Obj := TJsonObject.Create;
  if Self.Mat <> nil then
    Obj.AddPair('Mat', Self.Mat.ToJson);
  Obj.AddPair('Menge', FloatToStr(Self.Menge));
  Obj.AddPair('CreatedAt', DateTimeToStr(Self.CreatedAt));
  Obj.AddPair('TransmittedAt', DateTimeToStr(Self.TransmittedAt));
  Obj.AddPair('PersonalNr', Self.PersonalNr);
  Obj.AddPair('Fak', Self.Fak.ToJson);
  Obj.AddPair('Name', Self.Name);
  Obj.AddPair('Vorname', Self.Vorname);
  Result := Obj.ToJson;
  Obj.Free;
end;

end.
